import type { InputState } from './actions';

/** How far a finger must move for one lane change. Large enough that a small wobble doesn't steer. */
const SWIPE_MIN_PX = 44;

/** Swipe left/right to change lane, swipe up to hop. Pedals are separate DOM buttons (ui/hud/touchPedals). */
export function bindSwipes(input: InputState, surface: HTMLElement): () => void {
  let startX = 0;
  let startY = 0;
  let tracking = false;

  const onStart = (event: PointerEvent): void => {
    if (event.pointerType === 'mouse') return;
    tracking = true;
    startX = event.clientX;
    startY = event.clientY;
  };
  const onMove = (event: PointerEvent): void => {
    if (!tracking) return;
    const dx = event.clientX - startX;
    const dy = event.clientY - startY;
    if (Math.abs(dx) > SWIPE_MIN_PX && Math.abs(dx) > Math.abs(dy)) {
      input.press(dx < 0 ? 'laneLeft' : 'laneRight');
      startX = event.clientX;
      startY = event.clientY;
    } else if (dy < -SWIPE_MIN_PX * 1.5 && Math.abs(dy) > Math.abs(dx)) {
      input.press('hop');
      tracking = false;
    }
  };
  const onEnd = (): void => {
    tracking = false;
  };

  surface.addEventListener('pointerdown', onStart);
  surface.addEventListener('pointermove', onMove);
  surface.addEventListener('pointerup', onEnd);
  surface.addEventListener('pointercancel', onEnd);
  return () => {
    surface.removeEventListener('pointerdown', onStart);
    surface.removeEventListener('pointermove', onMove);
    surface.removeEventListener('pointerup', onEnd);
    surface.removeEventListener('pointercancel', onEnd);
  };
}
